import { Route, Routes } from "react-router-dom";
import Login from "pages/Login";
import SuperAdminLogin from "pages/SuperAdminLogin";
import CompanyLogin from "pages/CompanyLogin";
import Layout from "./components/layout/Layout";
import SuperAdminLayout from "./components/layout/SuperAdminLayout";
import CompanyLayout from "./components/layout/CompanyLayout";
import PrivateRoute from "components/routes/PrivateRoute";

function App() {
  return (
    <Routes>
      <Route path="/login/:id" element={<Login />} />
      <Route path="/login/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/super-admin-login" element={<SuperAdminLogin />} />
      <Route path="/company-login" element={<CompanyLogin />} />
      <Route path="/super-admin/*" element={<SuperAdminLayout />} />
      <Route path="/company/*" element={<CompanyLayout />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default App;
